/* eslint-disable */
export default {
  downloadSuccess: 'Journal téléchargé.',
  downloadFail:
    'Échec du téléchargement du journal d’erreurs. Veuillez réessayer.',
} as const;

// @key: @#@"downloadSuccess"@#@ @source: @#@"Log downloaded."@#@
// @key: @#@"downloadFail"@#@ @source: @#@"Error log download failed. Please try again."@#@
